/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MenuItem {
  /** @example 1 */
  id?: number
  /** @example null */
  parentId?: number
  /** @example "Home" */
  label?: string
  /** @example "Home" */
  labelEng?: string
  /** @example "home" */
  icon?: string
  /** @example "/" */
  url?: string
  /** @example "test" */
  to?: string
  /** @example "_blank" */
  target?: string
  /** @example "2024-12-01 01:00:00" */
  createdAt?: string
  items: MenuItem[]
  parameters?: object
}

export interface Member {
  loginId?: string
  companyId?: number
  companyName?: string
  companyNameEng?: string
  telephone?: string
  email?: string
  bizNumber?: string
  foreignFlag?: string
}

export interface SiteConfigDto {
  fairMasterId: number
  fairMasterCode: string
  siteUrl: string
  siteName: string
  siteNameEng: string
  subFairMasterIds?: string
  status: 'Using' | 'Closed'
  /** @format uri */
  logoUrl?: string
  /** @format uri */
  logoUrlEng?: string
  basePath?: string
  primaryColor?: string
  supportLocales: string[]
  useEnglishPage?: boolean
  /** @example "02-6121-6400" */
  contactTel?: string
  /** @example "test.es@esgroup.net" */
  contactEmail?: string
  /** @example "참가기업" */
  exhibitorLabel?: string
  organizerName?: string
  organizerNameEng?: string
  organizerCeoName?: string
  organizerCeoNameEng?: string
  organizerBizNo?: string
  organizerAddress?: string
  organizerAddressEng?: string
  organizerZipCode?: string
  organizerFaxNo?: string
  organizerTelNo?: string
  organizerEmail?: string
  organizerHomepage?: string
}

export interface Address {
  ZIPCODE?: string
  ADDR_ROAD?: string
  ADDR_DETAIL?: string
}

export interface FairDto {
  /** @example 797 */
  id?: number
  /** @example "2025 서울경향하우징페어(춘계)" */
  name?: string
  /** @example "2025 Seoul Kyunghyang Housing Fair (Spring)" */
  nameEng?: string
  /** @example "2025-04-24" */
  fairStartDate?: string
  /** @example "2025-04-27" */
  fairEndDate?: string
  /** @example "2025-01-01 00:00:00" */
  exhibitReqFrom?: string
  /**
   * @format date-time
   * @example "2025-04-26 23:59:59"
   */
  exhibitReqTo?: string
  /** @example "진행중" */
  status?: string
  /** @example 5 */
  fairMasterId?: number
  /** @example "경향하우징페어" */
  fairMasterName?: string
  /** @example "Kyunghyang Housing Fair" */
  fairMasterNameEng?: string
  /** @example false */
  isTestable?: boolean
  venue?: number
  companyFairStatusDesc: string
  /** @example true */
  isDisplay?: boolean
  /** @example null */
  exhibitReqPeriodDesc?: string
  supportLocales?: string[]
}

export interface Fair {
  /** @example 797 */
  id?: number
  /** @example "2025 서울경향하우징페어(춘계)" */
  name?: string
  /** @example "2025 Seoul Kyunghyang Housing Fair (Spring)" */
  nameEng?: string
  /** @example "2025-04-24" */
  fairStartDate?: string
  /** @example "2025-04-27" */
  fairEndDate?: string
  /** @example "진행중" */
  status?: string
  /** @example 5 */
  fairMasterId?: number
  venue?: number
  bankName?: string
  bankAccountNo?: string
  bankAccountHolder?: string
  contactPhoneNo?: string
  contactPhoneNoForVisitor?: string
  homepage?: string
  contactEmail?: string
  reqStartDate?: string
  reqEndDate?: string
  /** @example "KOREA" */
  fairMasterCd?: string
}

export interface VerifyCodeAndFetchInviteInfoDto {
  fairId?: number
  fairMasterId?: number
  /** @example "M" */
  checkType?: string
  /** @example "01012341234" */
  checkTarget?: string
  /** @example "123456" */
  checkCode?: string
  ivctid?: number
}

export interface Company {
  /** @example "" */
  id?: number
  /** @example "" */
  name?: string
  /** @example "" */
  nameEng?: string
  /** @example "" */
  brandName?: string
  /** @example "" */
  brandNameEng?: string
  /** @example "" */
  bizNumber?: string
  /** @example "" */
  ceoName?: string
  /** @example "" */
  zipCode?: string
  /** @example "" */
  addr?: string
  /** @example "" */
  addrDetail?: string
  /** @example "" */
  addrEng?: string
  /** @example "90" */
  nation?: string
  /** @example "South Korea" */
  nationDesc?: string
  /** @example "" */
  homepage?: string
  /** @example "" */
  bizType?: string
  /** @example "" */
  categoryType?: string
  /** @example "" */
  isOverseaCompany?: boolean
  /** @example "" */
  ceoEmail?: string
  /** @example "" */
  ceoTelNo?: string
  /** 회사대표 번호 */
  companyTelNo?: string
  /** 회사대표 팩스번호 */
  companyFaxNo?: string
  /** 회사대표 이메일 */
  companyEmail?: string
}

export interface SubmitInviteApplicationResult {
  /** @example "success" */
  status?: string
  message?: string
  errorCode?: number
  data?: SubmitInviteApplicationResultData
}

export interface SubmitInviteApplicationResultData {
  /** @example "KOR" */
  langType?: string
  couponCode?: string | null
  alreadyCoupon?: boolean | null
  fair?: object | null
  companyFairReq?: object | null
  preRegistrationUrl?: string | null
  inviteCompleteContent?: string | null
  inviteCompleteContentEng?: string | null
}

export interface Exhibitor {
  fairId?: number
  companyId?: number
  exhibitorId?: number
  /** @example "CompleteApproval" */
  status?: 'CompleteApproval' | 'WaitApproval' | 'NotSet'
  boothNumber?: string
}

export interface ImageThumbnail {
  url?: string
  width?: number
  height?: number
  originalUrl?: string
}

export interface FairCouponGuide {
  visitorSmsInviteGuideUrl?: string
  companySmsInviteGuideUrl?: string
}

export interface CompanyJoinDto {
  /** @example "123-12-12315" */
  bizNumber: string
  /** @example "에이비씨컴패니" */
  companyName: string
  /** @example "ABC Company" */
  companyNameEng: string
  /** @example "이상원" */
  ceoName: string
  /** @example "hM8yI@example.com" */
  email: string
  /** @example "0212341234" */
  telephone: string
  /** @example "0212341234" */
  fax?: string
  /** @example "http://abc.com" */
  homepageUrl?: string
  /** @example "12345" */
  zipCode: string
  /** @example "서울특별시 마포구 참마로 1" */
  addr: string
  /** @example "우리집" */
  addrDetail: string
  /** @example "1, Cham-ro, Mapo-gu, Seoul" */
  addrEng?: string
  /**
   * 국가코드: MASTER_CODE.MASTER_CODE_GROUP_ID = 47
   * @example "90"
   */
  nation?: string
  /** @example "무" */
  bizType: string
  /** @example "IT" */
  industry: string
  /** @example "test999" */
  loginId: string
  /** @example "qwe12#" */
  password: string
  /** @example "qwe12#" */
  passwordConfirm: string
  /** @default false */
  isOverseaCompany: boolean
  /** @default false */
  isAgree: boolean
  /** @default false */
  isMarketingAgree?: boolean
  /** @example 5 */
  fairMasterId?: number
  /** @example "123456" */
  emailCertCode?: string
}

export interface ExhibitorReqPromotion {
  companyFairPromotionId?: number | null
  exhibitorId?: number
  dbstatus?: string
  companyName?: string
  companyNameEng?: string
  addr?: string
  addrDetail?: string
  zipcode?: string
  addrEng?: string
  telNo?: string
  faxNo?: string
  email?: string
  homepage?: string
  title?: string
  blogAccount?: string
  facebookAccount?: string
  instagramAccount?: string
  twitterAccount?: string
  kakaostoryAccount?: string
  etcSnsAccount?: string
  companyInfo?: string
  companyInfoEng?: string
  tag?: string
  country?: string
  companyId?: number
}

export interface ExhibitorPromotionCategory {
  companyFairPromotionId?: number
  fairCategoryMasterId?: number
  fairCategoryId?: number
}

export interface ExhibitorInviteLink {
  token?: string
  code?: string
}

export interface ExhibitorReqInfo {
  companyName?: string
  companyNameEng?: string
  fairDesc?: string
  addr?: string
  addrDetail?: string
  zipCode?: string
  ceoName?: string
  ceoTelNo?: string
  ceoEmail?: string
  telNo?: string
  fax?: string
  email?: string
  bizNo?: string
  bizType?: string
  bizDesc?: string
  homepage?: string
  categoryMasterKr?: string
  categoryKr?: string
  displayItems?: string
  displayItemsEng?: string
  boothNumber?: string
  staffName?: string
  staffDept?: string
  staffPosition?: string
  staffPhone?: string
  staffMobile?: string
  staffEmail?: string
  staffFax?: string
  taxStaffName?: string
  taxStaffDept?: string
  taxStaffPosition?: string
  taxStaffPhone?: string
  taxStaffMobile?: string
  taxStaffEmail?: string
  taxStaffFax?: string
  invitationAddr?: string
  invitationAddrDetail?: string
  invitationZipcode?: string
  invitationCount?: number
  brandName?: string
  brandNameEng?: string
  addSalesAmt?: number
  addSalesAmtDesc?: string
  fairPlace?: number
  fairPlaceEtcDesc?: string
  fairPlaceDesc?: string
  fairPlaceEngDesc?: string
  fairStrDate?: string
  fairEndDate?: string
  fairViralDesc?: string
  createDate?: string
}

export interface ExhibitorInfoImage {
  imgIdx?: number
  companyFairInfoId?: number
  imgUrl?: string
  imgRep?: string
  imgThumbUrl?: string
  sortNo?: number
  imgInstaYn?: string
  isDeleted?: boolean
  newIndex?: number
  file?: object
  fileName?: string
}

export interface ExhibitorReceipt {
  /** @example "" */
  exhibitorId?: number
  /** @example "" */
  boothSupplyAmount?: number
  /** @example "" */
  subSupplyAmount?: number
  /** @example "" */
  etcSupplyAmount?: number
  /** @example "" */
  supplyDiscountAmount?: number
  /** @example "" */
  boothDiscountAmount?: number
  /** @example "" */
  subDiscountAmount?: number
  /** @example "" */
  specialDiscountAmount?: number
  /** @example "" */
  totalSupplyAmount?: number
  /** @example "" */
  totalDiscountAmount?: number
  /** @example "" */
  totalTaxAmountWithDiscount?: number
  /** @example "" */
  totalSupplyAmountWithDiscount?: number
  /** @example "" */
  totalDepositAmount?: number
  /** @example "" */
  saleMemo?: string
}

export interface ExhibitorDoc {
  /** @example 999 */
  id?: number
  /** @example 999 */
  exhibitorId: number
  /** @example "메쎄이상" */
  brandName: string
  /** @example "Messe Esang" */
  brandNameEng: string
  /** @example "메쎄이상" */
  companyName?: string
  /** @example "Messe Esang" */
  companyNameEng?: string
  onsiteStaffCount?: number
  maxOnsiteStaffCount?: number
}

export interface SingleFileUploadDto {
  /** @example "http://localhost:8001/media/test/of/media/test.jpg" */
  url?: string
  /** @example "test.jpg" */
  filename?: string
  /** @example "success" */
  message?: string
  /** @example "test.jpg" */
  originalFilename?: string
  thumbnails: ImageThumbnail[]
}

export interface PressRelease {
  exhibitorId: number
  brandId?: number
  companyNameKor: string
  companyNameEng: string
  mainImageUrl?: string
  pressReleaseUrl?: string
  interviewUrl?: string
}

export interface Promotion {
  id?: number
  exhibitorId?: number
  companyName?: string
  companyNameEng?: string
  addr?: string
  addrDetail?: string
  zipcode?: string
  telNo?: string
  faxNo?: string
  email?: string
  homepage?: string
  title?: string
  blogAccount?: string
  facebookAccount?: string
  instagramAccount?: string
  twitterAccount?: string
  kakaostoryAccount?: string
  etcSnsAccount?: string
  canDisplay?: boolean
  canMainDisplay?: boolean
  sortOrder?: string
  companyInfo?: string
  companyInfoEng?: string
  tag?: string
  addrEng?: string
  companyProfileUrl?: string
  companyPremium?: string
  country?: string
  createUser?: string
  createDate?: string
  updateUser?: string
  updateDate?: string
  brands: PromotionBrand[]
}

export interface CompanySmsCoupon {
  totCnt?: number
  rowNo?: number
  receiveMobile?: string
  couponCode?: string
  sendYn?: 'Y' | 'N'
  sendDate?: string
  useYn?: 'Y' | 'N'
  useDate?: string
  useMobile?: string
}

export interface FairInfo {
  /** @example 777 */
  fairId?: number
  /** @example "2025 일러스트코리아 코엑스 1" */
  fairName?: string
  /** @example "2025 Illustration Korea Coex 1" */
  fairNameEng?: string
  /** @example "2025 서울 일러스트코리아" */
  fairDesc?: string
  /** @example "2025 SEOUL ILLUSTRATION KOREA" */
  fairDescEng?: string
  /** @example "2025-05-01 10:00:00.000" */
  fairStartDate?: string
  /** @example "2025-05-04 18:00:00.000" */
  fairEndDate?: string
  /** @example "10:00" */
  fairStartTime?: string
  /** @example "18:00" */
  fairEndTime?: string
  /** @example "(입장마감 17:30)" */
  enterEndTime?: string
  /** @example 50 */
  fairMasterId?: number
  /** @example "ILUST" */
  fairMasterCd?: string
  /** @example "2025" */
  fairYear?: string
  /** @example "0" */
  fairStatus?: string
  /** @example "진행중" */
  fairStatusDesc?: string
  /** @example "1" */
  fairPlace?: string
  /** @example "코엑스" */
  fairPlaceDesc?: string
  /** @example "Hall B" */
  fairPlaceEtcDesc?: string
  /** @example "8010" */
  fairSquareMeasure?: string
  fairDates?: {
    /** @example "2024-10-14 00:00:00.000" */
    reqStartDate?: string
    /** @example "2025-04-30 23:59:00.000" */
    reqEndDate?: string
    /** @example "2024-11-04 00:00:00.000" */
    preRegStartDate?: string
    /** @example "2025-04-30 23:59:00.000" */
    preRegEndDate?: string
    /** @example "2024-10-14 00:00:00.000" */
    smsInviteStartDate?: string
    /** @example "2025-04-30 23:59:00.000" */
    smsInviteEndDate?: string
  }
  bankInfo?: {
    /** @example "기업" */
    bankName?: string
    /** @example "477-030938-01-036" */
    bankAccountNo?: string
    /** @example "메쎄이상" */
    bankAccountHolder?: string
  }
  contactInfo?: {
    /** @example "(주)메쎄이상" */
    companyName?: string
    /** @example "02-6121-6252" */
    contactCompany?: string
    /** @example "02-6121-6234" */
    contactVisitor?: string
    /** @example "ilko@esgroup.net" */
    contactEmail?: string
    /** @example "https://illustrationkorea.co.kr/coex/" */
    contactHomepage?: string
  }
  /** @example "12000" */
  ticketPrice?: string
  alimtalkInfo?: {
    /** @example "5c11be53ba52c6eda783f1698bb32f91ee406318" */
    senderKey?: string
    /**
     * @example "
     * ※ 입장권 프로모션의 경우, 프로모션 기간 내 사전등록 및 사전결제까지 진행하여야 적용됩니다.
     *
     * ※ 사전등록만 진행 후 현장결제시 현장가로 결제 후 티켓 수령 가능합니다."
     */
    preRegAlimtalkNotice?: string
    /** @example "UBR.YAvSu97315-1WvEIW7eNu5PeGq1j51a3L9SS" */
    certnoTemplateCode?: string
    /** @example "0808701074" */
    smsSendDncNumber?: string
  }
  /** @example "2025-04-30 23:59:00.000" */
  smsInviteEndDate?: string
  /** @example "2024-10-14 00:00:00.000" */
  smsInviteStartDate?: string
  /** @example "Y" */
  dateOpenFlag?: string
  /** @example "Y" */
  openFlag?: string
}

export interface PromotionBrand {
  id?: number
  promotionId?: number
  brandNameKr?: string
  brandNameEng?: string
  companyBrandLogoUrl?: string
  companyBrandLogoUrl2?: string
  companyBrandInfo?: string
  companyBrandInfoEng?: string
  companyProduct1Url?: string
  companyProduct2Url?: string
  companyProduct3Url?: string
  companyProduct4Url?: string
  companyProduct1DescKor?: string
  companyProduct2DescKor?: string
  companyProduct3DescKor?: string
  companyProduct4DescKor?: string
  companyProduct1DescEng?: string
  companyProduct2DescEng?: string
  companyProduct3DescEng?: string
  companyProduct4DescEng?: string
  promotionInfo?: string
  promotionInfoEng?: string
  companyBrandProfileUrl?: string
  newsUrl?: string
  brandType?: string
  companyBrandMainUrl?: string
  fairCategoryMasterId?: number
  fairCategoryId?: number
  tag?: string
  companyBrandLogoUrlThumb?: string
  companyBrandMainUrlThumb?: string
  companyProductDetailDesc?: string
  companyBrandProfileUrl2?: string
  companyBrandProfileUrl3?: string
  companyBrandProfileUrl4?: string
  companyProductDetailUrl?: string
  productSize?: string
  productAsq?: string
  productCharacter?: string
  snsUrl_1?: string
  snsUrl_2?: string
  snsUrl_3?: string
  snsUrl_4?: string
  homepageUrl_1?: string
  homepageUrl_2?: string
  homepageUrl_3?: string
  homepageUrl_4?: string
  newsUrlUpdateDate?: string
  companyProduct1KorLinkUrl?: string
  companyProduct2KorLinkUrl?: string
  companyProduct3KorLinkUrl?: string
  companyProduct4KorLinkUrl?: string
  companyProduct1EngLinkUrl?: string
  companyProduct2EngLinkUrl?: string
  companyProduct3EngLinkUrl?: string
  companyProduct4EngLinkUrl?: string
  interviewUrl?: string
  createUser?: string
  createDate?: string
  updateUser?: string
  updateDate?: string
}

export interface BannerForm {
  id?: number
  exhibitorId?: number
  companyName?: string
  staffName?: string
  staffPosition?: string
  staffMobile?: string
  staffEmail?: string
  address?: string
  addressDetail?: string
  zipCode?: string
  bannerSize?: string
  bannerSizeId?: number
  bannerPlace?: string
  createDate?: string
  createUser?: string
  updateDate?: string
  updateUser?: string
}

export interface BannerSize {
  id?: number
  fairMasterId?: number
  width?: number
  height?: number
  unit?: string
  displayText?: string
}

/** 시설 요청 정보 */
export interface FacilityApplication {
  id?: number
  exhibitorId?: number
  facilityId?: number
  requestCount?: string
  content?: string
}

export interface Facility {
  sequence?: string
  id?: number
  fairId: number
  categoryValue: number
  facilityType: 'booth' | 'others' | 'etc'
  categoryName?: string
  categoryNameEng?: string
  minimumQuantity: number
  maximumQuantity: number
  price: number
  name?: string
  description?: string
  imageUrl?: string
  quantityUnit?: string
  areaPrice?: number
  designPrice?: number
  constructPrice?: number
  useAreaDiscount?: boolean
  useDesignDiscount?: boolean
  useConstructDiscount?: boolean
  useView?: boolean
  sortOrder?: number
  saleCharge?: number
  isForeigner?: boolean
  foreignPrice?: number
}

export interface FacilityReq {
  id?: number
  exhibitorId?: number
  facilityId?: number
  quantity?: number
  content?: string
}

export interface FacilitiesForm {
  exhibitorId?: number
  facilityStaffName?: string
  companyName?: string
  email?: string
  telephone?: string
  fairName?: string
  fairEmail?: string
  facilities: FacilityReq[]
}

export interface FairCategory {
  masterId?: number
  id?: number
  name?: string
  nameEng?: string
  tag?: string
  children: FairCategory[]
}

export interface FairCategorySub {
  fairCategoryId?: number
  subCategoryName?: string
  subCategoryNameEng?: string
}

export interface FairApplicationAddInfo {
  id?: number
  groupId?: number
  name?: string
  orderNo?: number
}

export interface FairApplicationAddInfoGroup {
  groupId?: number
  groupName?: string
  isMultiple?: string
  items: FairApplicationAddInfo[]
}

export interface InviteApplicationForm {
  /** 시설요청 정보 */
  Agree?: Agree
  /** 설문조사 PKID 리스트 */
  FAIR_MASTER_POLL_IDS?: number[]
  /** 초대코드 */
  InviteToken?: string
  /** 언어타입 */
  LANG_TYPE?: string
  /** 설문조사 내용 */
  PollDescs?: object
  /** 설문조사 값 */
  PollValues?: object
  /** 등록자 정보 */
  RegInfo?: RegInfo
  /** 참관객 정보 */
  VisitorInfo?: VisitorInfo
  /** ZoneTracker 정보 */
  ZoneTracker?: ZoneTracker
}

export interface ZoneTracker {
  /** 광고 매체 커뮤니케이션 코드 */
  AD_COM?: string
  /** 사용자 에이전트 (User Agent) */
  AGENT?: string
  /** 캠페인 코드 */
  CAMP_CODE?: string
  /** 사용자 IP 주소 */
  IP_ADDR?: string
  /** 유입 경로 코드 */
  IR_CD?: string
  /** 참조(리퍼러) URL */
  REFER_URL?: string
  /** 사용자 ID */
  USER_ID?: string
  /** 존 코드 */
  ZONE_CODE?: string
}

export interface VisitorInfo {
  /** 참관객 이름 */
  VISITOR_NAME?: string
  /** 휴대전화 번호 */
  MOBILE?: string
  /** 이메일 주소 */
  EMAIL?: string
  /** 유선 전화번호 */
  TEL_NO?: string
  /** 주소 */
  ADDR_DESC?: string | null
  BIRTH?: string
  /** 성별 */
  GENDER?: string
  /** 국가 */
  NATION?: string
  /** 회사명 */
  COMPANY?: string
  /** 부서명 */
  DEPT?: string
  /** 직책 */
  POSITION?: string
  /** 회사명 (영문) */
  COMPANY_ENG?: string
  /** 부서명 (영문) */
  DEPT_ENG?: string
  /** 직책 (영문) */
  POSITION_ENG?: string
  /** 이름 (영문) */
  FIRST_NAME?: string
  /** 성 (영문) */
  LAST_NAME?: string
  /** 국가 전화번호 코드 */
  COUNTRY_CALLING_CODE?: string | null
}

export interface RegInfo {
  /** 생성자 */
  CREATE_USER?: string
  /** 회원구분 */
  ES_MEMBER_TYPE?: string
  /** 기타 정보 */
  ETC?: string
  /** 전시회 ID */
  FAIR_ID?: number | null
  /** 전시회 마스터 ID */
  FAIR_MASTER_ID?: number | null
  /** 발급 정보 */
  ISSUE?: string
  /** 국가 */
  NATION?: string
  /** REG_METHOD */
  REG_METHOD?: string
  /** REG_TYPE */
  REG_TYPE?: string
  /** 참관객 고유 ID */
  VISITOR_ID?: number | null
  /** 참관객 유형 */
  VISITOR_TYPE?: string
}

export interface Agree {
  /** 이메일 수신 동의 여부 */
  FLAG_EMAIL?: string
  /** SMS 수신 동의 여부 */
  FLAG_SMS?: string
  /** 푸시 알림 수신 동의 여부 */
  FLAG_PUSH?: string
}

export interface FairApplicationForm {
  /** 참가기업 PKID (COMPANY_FAIR_REQ_ID) */
  exhibitorId?: number
  /** 신청하는 FAIR_ID */
  fairId?: number
  companyId?: number
  /** 회사명(국문) */
  companyName?: string
  /** 회사명(영문) */
  companyNameEng?: string
  /** 브랜드명(국문) */
  brandName?: string
  /** 브랜드명(영문) */
  brandNameEng?: string
  /** 사업자번호 */
  bizNumber?: string
  /** 사업자등록증 업로드 위치 */
  bizFileUploadURL?: string
  /** 대표자 이름 */
  ceoName?: string
  /** 대표자 이메일 */
  ceoEmail?: string
  /** 대표자 전화번호 */
  ceoTelNo?: string
  /** 주소 */
  address?: string
  /** 상세주소 */
  addressDetail?: string
  /** 우편번호 */
  zipCode?: string
  /** 주소(영문) */
  addressEng?: string
  /** 상세주소(영문) */
  addressDetailEng?: string
  /** 국가 마스터 코드 */
  nation?: string
  /** 초청장발송 주소 */
  invitationAddress?: string
  /** 초청장발송 상세주소 */
  invitationAddressDetail?: string
  /** 초청장발송 우편번호 */
  invitationZipCode?: string
  /** 오프라인 초청장 갯수 */
  invitationCount?: number
  /** 회사대표 번호 */
  companyTelNo?: string
  /** 회사대표 전화번호 */
  companyMobileNo?: string
  /** 회사대표 이메일 */
  companyEmail?: string
  companyEmailGroup?: number
  /** 회사대표 팩스번호 */
  companyFaxNo?: string
  /** 홈페이지 URL */
  homepage?: string
  /** 전시품목(국문) */
  displayItem?: string
  /** 전시품목(영문) */
  displayItemEng?: string
  /** 유입경로 */
  inflowPath?: string
  /** 유입경로(비고) */
  inflowPathRef?: string
  /** 카테고리 PKID(대분류) */
  fairCategoryMasterId?: number
  /** 카테고리 PKID(중분류) */
  fairCategoryId?: number
  /** 회사소개 */
  companyDescription?: string
  /** 해외참가기업 신청서 구분값(기본값 N) */
  isForeignApply?: boolean
  /** 홍보물 표기용 회사명(국문) */
  promotionName?: string
  /** 홍보물 표기용 회사명(영문) */
  promotionNameEng?: string
  /** 추가정보 리스트 */
  addInfoList: FairApplicationAddInfo[]
  /** 추가정보 이미지 리스트 */
  addInfoImages: ExhibitorInfoImage[]
  /** 참가사 리스트 */
  staffList: ExhibitorStaff[]
  /** 시설요청 정보 */
  facilitiesForm: FacilitiesForm
}

export interface ExhibitorStaff {
  id?: number
  fairId?: number
  companyId?: number
  exhibitorId?: number
  name?: string
  /** 직원 역할 (StaffRole enum) */
  role?: 'General' | 'Sales' | 'Tax' | 'Online' | 'OnSite' | 'BusinessMatching'
  department?: string
  position?: string
  /** @format email */
  email?: string
  mobile?: string
  telNo?: string
  fax?: string
  createUser?: string
  /** @format date-time */
  createTime?: string
}

export interface ExhibitorCsStaff {
  id?: number
  exhibitorId?: number
  staffName?: string
  staffPosition?: string
  staffPhone?: string
  secondStaffPhone?: string
  secondStaffEmail?: string
  isAgreement?: string
  createUser?: string
  createDate?: string
  fairId?: number
}

export interface ExhibitorConstructor {
  id?: number
  exhibitorId?: number
  /**
   * 등록 시공업체 시공: 1,
   * 기업 내 자체시공: 2,
   * 홍보 에이전시: 3
   */
  constructorType?: 1 | 2 | 3
  constructorTypeDesc?: string
  constructorCompanyName?: string
  constructorTelNo?: string
  chargeName?: string
  chargeMobile?: string
  chargeEmail?: string
  createUser?: string
  createDate?: string
}

export interface FairManualFile {
  /** @example 4206 */
  FAIR_FILE_ID?: number
  /** @example 685 */
  FAIR_ID?: number
  /** @example 6 */
  TOT_CNT?: number
  /**
   * 파일수량에 따른 row
   * @example 4
   */
  ROW_NO?: number
  /** @example "2024 이에스지친환경대전 코엑스 1" */
  FAIR_NAME?: string
  /** @example "2024 대한민국ESG친환경 대전" */
  FAIR_DESC?: string
  /**
   * MASTER_CODE_GROUP_ID = 16
   * @example 10
   */
  FILE_TYPE?: number
  /**
   * MASTER_CODE의 CODE_NAME
   * @example "참가기업 메뉴얼"
   */
  CODE_NAME?: number
  /** @example "01. 2024대한민국ESG친환경대전_참가기업 공사 운영 매뉴얼.pdf" */
  FILE_NAME?: string
  FILE_URL?: string
  CONTENT?: string
  /**
   * admin_user id
   * @example "yyji.es"
   */
  CREATE_USER?: string
  /** @example "2024-09-20 20:37:27.343" */
  CREATE_DATE?: string
  /** @example "유예지" */
  CREATE_USER_NAME?: string
  /** @example "N" */
  FLAG_FOREIGN?: string
  /** @example "이에스지친환경대전" */
  FAIR_MASTER_NAME?: string
}

export interface CompanyPrize {
  use_yn?: string
  prizesId?: number
  exhibitorId?: number
  fairId?: number
  name?: string | null
  qty?: number | null
  price?: number | null
  description?: string | null
  imageUrl?: string | null
  shippingType?: string | null
  shippingFee?: number | null
  dbstatus?: string
  createUser?: string
  regGb?: string
}

export interface CompanyNames {
  value?: string
  text?: string
}

export interface ExhibitorOnsiteStaff {
  staffId?: number
  exhibitorId?: number
  staffName?: string
  staffDept?: string
  staffPosition?: string
  staffNameEng?: string
  staffDeptEng?: string
  staffPositionEng?: string
  staffPhone?: string
  staffEmail?: string
  companyName?: string
  companyNameEng?: string
}

export interface OnsiteStaffDto {
  exhibitorId?: number
  companyName?: string
  companyNameEng?: string
  user?: string
  staffs?: ExhibitorOnsiteStaff[]
}

export interface DeleteOnsiteStaffDto {
  staffId?: number
  exhibitorId?: number
}

export interface CompanyFairDocDto {
  exhibitorId?: number
  companyName?: string
  companyNameEng?: string
  staffCount?: number
  user?: string
}

export interface CompanyPreFairReq {
  exhibitorId?: number
}

export interface Agreement {
  /** 약관 유형 */
  agreementType?: AgreementType
  /**
   * 약관 내용
   * @example "약관 내용입니다."
   */
  content?: string
}

export interface CompanyFairInfoImage {
  IMG_IDX?: number
  COMPANY_FAIR_INFO_ID?: number
  IMG_URL?: string
  IMG_REP?: string
  IMG_THUMB_URL?: string
  SORT_NO?: number
  IMG_INSTA_YN?: string
  CREATE_USER?: string
  /** @format date-time */
  CREATE_DATE?: string
  UPDATE_USER?: string
  /** @format date-time */
  UPDATE_DATE?: string
}

export interface ApiResponse {
  State?: string
  Data?: object
  Message?: string
  ErrorCode?: number
  err_cd?: number
  err_msg?: string
  state?: string
}

/** 직원 역할 (StaffRole enum) */
export enum StaffRole {
  General = 'General',
  Sales = 'Sales',
  Tax = 'Tax',
  Online = 'Online',
  OnSite = 'OnSite',
  BusinessMatching = 'BusinessMatching'
}

export interface ApplicationFormSettings {
  /** 초청장 주소 입력유무 */
  useInvitation?: boolean
  /** 전시담당자 전화번호 입력유무 */
  isRequireFairTel?: boolean
  /** 전시담당자 팩스 입력 유무 */
  isRequireFairFax?: boolean
  /** 세금계산서 담당자 전화번호 입력유무 */
  isRequireTaxTel?: boolean
  /** 세금계산서 담당자 팩스 입력유무 */
  isRequireTaxFax?: boolean
  /** 추가 담당자 입력 유무 (deprecated) */
  isRequireAddStaff?: boolean
  /** 온라인 담당자 입력유무 */
  isRequireOnlineStaff?: boolean
  /** 온라인 담당자 전화번호 입력유무 */
  isRequireOnlineStaffTel?: boolean
  /** 온라인 담당자 팩스 입력유무 */
  isRequireOnlineStaffFax?: boolean
  /** 현장 담당자 입력유무 */
  isRequireOnsiteStaff?: boolean
  /** 현장 담당자 전화번호 입력유무 */
  isRequireOnsiteStaffTel?: boolean
  /** 현장 담당자 팩스 입력유무 */
  isRequireOnsiteStaffFax?: boolean
  /** 전시 추가정보 입력유무 */
  isRequireAddInfo?: boolean
  /** 전시회 초청장 증가 단위 */
  invitationUnitCount?: number
  /** 전시회 초청장 최대 발급수 */
  invitationMaxCount?: number
  /**
   * 출품 이미지 사용 유무
   * @default false
   */
  useExhibitionImage?: boolean
  /**
   * ## 출품 이미지 라벨
   * - 캣페스타: 출품 이미지
   * - 넥스트콘(NextCon), 뷰티썸(BeautySum), 카덱스(KADEX): 기업 로고
   * @default "출품 이미지"
   * @example "출품 이미지"
   */
  exhibitionImageLabel: string
  /**
   * ## 출품 이미지 라벨 (영문)
   * - 캣페스타: Exhibitor Image
   * - 넥스트콘(NextCon), 뷰티썸(BeautySum), 카덱스(KADEX): Company Logo
   * @default "출품 이미지"
   * @example "출품 이미지"
   */
  exhibitionImageLabelEng?: string
  /**
   * 출품 이미지 최소 개수
   * @example 3
   */
  exhibitionImageMinCount?: number
  /**
   * 출품 이미지 최대 개수
   * @example 10
   */
  exhibitionImageMaxCount?: number
  /**
   * USD 통화 강제 사용 유무
   * @default false
   */
  useUsdCurrencyOnly?: boolean
  /**
   * 외국인 초청장 사용 유무
   * @default false
   */
  useForeignerInvitation?: boolean
}

export interface FacilitiesRequestHistory {
  /** 시설물 담당자명 */
  facilityStaffName?: string
  /**
   * 시설물 신청 목록
   * @default []
   */
  facilities: FacilityReq[]
}

export interface SubmitApplicationResult {
  /** 참가기업 식별자 (COMPANY_FAIR_REQ_ID) */
  exhibitorId?: number
  /** 참가 신청서 식별자 (COMPANY_FAIR_INFO_ID) */
  fairApplicationId?: number
  /** 전시회 식별자 (FAIR_ID) */
  fairId?: number
  /** 오류 코드 */
  errorCode?: string
  /** 오류 메시지 */
  errorMessage?: string
}

/** 전시회 현장 내부 행사 */
export interface FairEvent {
  fairEventId?: number
  title?: string
  content?: string
  sort?: string
  imageUrl?: string
  type?: string
  fairId?: number
  exhibitorId?: number
  boothNumber?: string
  companyName?: string
  prNameKr?: string
  eventType?: string
  eventTypeDesc?: string
  encryptExhibitorId?: string
}

export interface BuyerInvitationDto {
  fairName?: string
  exhibitorId?: number
  companyName?: string
  companyNameEng?: string
  applicationFormUrl?: string
}

export interface FairPollDto {
  questionId?: number
  questionDesc?: string
  questionDescEng?: string
  instanceDescApp?: string
  sequence?: number
  instanceId?: number
  questionOrAnswer?: string
  questionType?: string
  businessType?: string
  fairPollType?: string
  etcType?: number
}

export interface ConsultPollDto {
  questionId?: number
  answerDesc?: string
}

export interface ConsultReqDto {
  visitorName?: string
  visitorArea?: string
  birthYear?: number
  exhibitorId?: number
  companyName?: string
  appliedAt?: string
  email?: string
  fairId?: number
  fairVisitorId?: number
  gender?: string
  mobile?: string
  occupation?: string
  consultPolls: ConsultPollDto[]
}

export interface CompanyCouponDto {
  id?: number
  companyId?: number
  fairId?: number
  companyName?: string
  exhibitItems?: string
  telNo?: string
  zipcode?: string
  address?: string
  homepage?: string
  brandLogoUrl?: string
  staffName?: string
  staffDept?: string
  staffPosition?: string
  staffMobile?: string
  staffEmail?: string
  maxCouponAmount?: number
  couponAmount?: number
  couponCount?: number
  usageConditionDesc?: string
  isRewarded?: boolean
  paymentPrice?: number
  depositAmount?: number
  bankName?: string
  bankAccount?: string
  depositBankName?: string
  depositDate?: string
  memo?: string
  canAccessCobeCouponPage?: boolean
  cobeCouponAgreeDate?: string
  isAgreeCobeCoupon?: boolean
  canAccessSelfCouponPage?: boolean
  selfCouponAgreeDate?: string
  isAgreeSelfCoupon?: boolean
  canAccessSettlementPage?: boolean
  transAgreeDate?: string
  isAgreeTrans?: boolean
}

export interface CompanyCouponInCobeDto {
  id?: number
  fairId?: number
  companyId?: number
  couponFlag?: number
  companyName?: string
  brandName?: string
  brandLogoUrl?: string
  exhibitItems?: string
  homepage?: string
  telNo?: string
  couponAmount?: number
  giftName?: string
  createdCount?: number
  createdCountByCompany?: number
  addedCount?: number
  usageConditionDesc?: string
  couponTitle?: string
  regDate?: string
  couponProductType?: string
  usedCount?: number
}

export interface FairDoc {
  id?: number
  fairId?: number
  staffCountPerBoothCount?: number
  brandMenuDescTop?: string
  brandMenuDescBottom?: string
  brandMenuDescTopEng?: string
  brandMenuDescBottomEng?: string
  brandNameExample?: string
  brandNameEngExample?: string
  brandNameLength?: number
  brandNameEngLength?: number
  brandSignImgUrl?: string
  brandSignImgForeignUrl?: string
}

export interface SimpleFileDto {
  /** @example "부스 디자인 1" */
  label?: string
  /** @example "부스 디자인 1.jpg" */
  filename?: string
  /** @example "http://localhost:8001/media/test/of/media/test.jpg" */
  url?: string
}

export interface OnsiteStaffOptionDto {
  /** @example false */
  useMultiLanguage?: boolean
  /** @example false */
  useQuantityOnly?: boolean
  /** @example 30 */
  maxStaffCount?: number
}

/** 회사 사업자 등록증 파일 */
export interface CompanyBusinessFile {
  id?: number
  companyId?: number
  fairId?: number
  fileName?: string
  sourceUrl?: string
  createUser?: string
  createTime?: string
}

/** 보도자료와 인터뷰의 신청서 파일 및 예시 링크 */
export interface PressReleaseAndInterviewDto {
  pressReleaseFile?: string
  pressReleaseGuideFile?: string
  pressReleaseExample?: ExampleLinkDto[]
  interviewFile?: string
  interviewExample?: ExampleLinkDto[]
}

export interface ExampleLinkDto {
  label?: string
  link?: string
}

/**
 * 약관 유형
 * @example "application_policy"
 */
export enum AgreementType {
  Join = 'join',
  JoinMarketing = 'join_marketing',
  ApplicationPolicy = 'application_policy',
  ApplicationCancelPolicy = 'application_cancel_policy',
  LinkonbizTerm = 'linkonbiz_term',
  LinkonbizPrivacy = 'linkonbiz_privacy',
  OnsiteStaffPolicy = 'onsite_staff_policy'
}

export interface FairGroupsByCategoryDto {
  /** @example "COATING" */
  key?: string
  /** @example "코팅 코리아" */
  name?: string
  /** @example "COATING KOREA" */
  nameEng?: string
  /** @example "https://d3ib83x3z60m0e.cloudfront.net/wp-content/uploads/sites/35/2025/03/26130535/9.png" */
  logoUrl?: string
}

export interface SendEmailDto {
  /**
   * 수신자 이메일
   * @format email
   */
  toEmail?: string
  /** 이메일 양식에 사용될 데이터 */
  data?: object
}

export interface VerifyEmailDto {
  /**
   * 이메일 주소
   * @format email
   * @example "exit.es@esgroup.net"
   */
  email: string
  /**
   * 전시회 ID
   * @example 808
   */
  fairId?: number
  /**
   * 전시회 마스터 ID
   * @example 23
   */
  fairMasterId?: number
  /**
   * 로그인 ID 포함 여부
   * @example false
   */
  includeLoginId?: boolean
  verifyType?: 'join' | 'change_email' | 'find_account'
  /** 언어 유형 */
  locale?: Locale
}

export interface CheckEmailDto {
  /**
   * 이메일 주소
   * @format email
   */
  email: string
  /** 인증 코드 */
  certCode: string
}

export interface CustomImageEditorConfigDto {
  /** 배경 이미지 */
  bgImageUrl?: string
  /**
   * 전시 카테고리에 따라 배경 이미지를 다르게 사용하는 경우 ex. 고기능소재위크 (FairKeyValue::FAIR_GROUPS_BY_CATEGORY 활용)
   * @example "COATING"
   */
  fairGroup?: string
  items?: CanvasItemConfigDto[]
}

export interface CanvasItemConfigDto {
  /** @example "QR" */
  name?: string
  /** @example 162 */
  x?: number
  /** @example 169 */
  y?: number
  /**
   * 특정 영역 내에 동적 텍스트를 가운데 정렬해야 할 때, 해당 영역의 시작점 X 좌표 입력
   * @example 10
   */
  startX?: number
  /**
   * 특정 영역 내에 동적 텍스트를 가운데 정렬해야 할 때, 해당 영역의 끝점 X 좌표 입력
   * @example 30
   */
  endX?: number
  /** @example 20 */
  fontSize?: number
  /** @example null */
  fill?: string
  /** @example 125 */
  width?: number
  /** @example 126 */
  height?: number
  imageUrl?: string
  /** @example false */
  draggable?: boolean
}

export interface PaybackChallengeConfigDto {
  /** 커스텀 초청장 사용 여부 */
  useCustomInvitation?: boolean
  benefits?: PaybackChallengeBenefits[]
}

export interface PaybackChallengeBenefits {
  condition?: string
  benefit?: string
  example?: string
}

export interface PromotionBannerConfigDto {
  /** 예시 이미지 */
  exampleImgUrl?: string
  bannerSettings?: CustomImageEditorConfigDto[]
}

export interface PaybackChallengeImage {
  fairId?: number
  companyId?: number
  type?: 'basic' | 'custom'
  imageUrl?: string
  updatedAt?: string
}

/** 페이백챌린지 이미지 타입 */
export enum PaybackChallengeImageType {
  Basic = 'basic',
  Custom = 'custom'
}

/**
 * 언어 유형
 * @default "ko"
 * @example "ko"
 */
export enum Locale {
  Ko = 'ko',
  En = 'en'
}

export interface ConsultingExhibitorDto {
  fairConsultId?: number
  exhibitorId?: number
  companyFairConsultId?: number
  companyId?: number
  companyName?: string
  brandName?: string
  logoUrl?: string
}

export interface Option {
  name?: string
  value?: string
}

export interface ConstructionCompanyConfigDto {
  options?: Option[]
  removalTimeDesc?: string
  additionalDesc?: string
}

export interface TextWithLangType {
  type?: string
  langType?: string
  contents?: string[]
}

export interface LinkWithThumbnail {
  imageUrl?: string
  link?: string
}

export interface LinkonbizConfigDto {
  linkonbizExamples?: LinkWithThumbnail[]
  snsExamples?: LinkWithThumbnail[]
  youtubeExamples?: LinkWithThumbnail[]
  newsletterExamples?: LinkWithThumbnail[]
  guideImageUrl?: string
  guideFileUrl?: string
  guideFileEngUrl?: string
  descTexts?: TextWithLangType[]
  imageBanner?: LinkWithThumbnail[]
}

export interface FairPromotionOption {
  id?: number
  fairId?: number
  useOneLineTitle?: boolean
  useSns?: boolean
  useAddInfo?: boolean
  useBrandLogo?: boolean
  useBrandInfo?: boolean
  useBrandInfoEng?: boolean
  useProductInfo?: boolean
  usePromotionInfo?: boolean
  usePromotionInfoEng?: boolean
  useBrandProfileUrl?: boolean
  useBrandMainImg?: boolean
  useNewsUrl?: boolean
  useInterviewUrl?: boolean
}

export interface BrandTypeDto {
  title?: string
  options?: Option[]
}

export interface OnlinePromotionConfigDto {
  useVideo?: boolean
  maxBrandCount?: number
  brandType?: BrandTypeDto
}

export interface ApiErrorResponse {
  /**
   * 실패 상태
   * @default false
   */
  success?: boolean
  /** 오류 메시지 */
  message?: string
}

export interface UpdateCompanyInfoDto {
  nameEng?: string
  ceoName?: string
  companyTelNo?: string
  companyFaxNo?: string
  email?: string
  homepage?: string
  zipCode?: string
  addr?: string
  addrDetail?: string
  addrEng?: string
  nation?: string
  bizType?: string
  categoryType?: string
  isEmailChanged?: boolean
}

/** 기간 상태 */
export enum PeriodStatus {
  WAIT = 'WAIT',
  ING = 'ING',
  END = 'END'
}

export interface FairPeriod {
  id?: number
  name?: string
  startDate?: string
  endDate?: string
  periodType?: string
  periodStatus?: 'WAIT' | 'ING' | 'END'
}

export interface ExhibitorFacilityDto {
  id?: number
  exhibitorId?: number
  facilityId?: number
  facilityGroup?: FacilityGroup
  requestedCount?: number
}

export enum FairKeyType {
  ApplicationCancelPolicy = 'application_cancel_policy',
  ApplicationPolicy = 'application_policy',
  ApplicationPolicyEng = 'application_policy_eng',
  BannerImage = 'banner_image',
  BasicImageInvitationConfig = 'basic_image_invitation_config',
  BidNoticeSearchKeywords = 'bid_notice_search_keywords',
  BoothDesignJson = 'booth_design_json',
  ConstructionCompanyConfig = 'construction_company_config',
  CustomImageInvitationConfig = 'custom_image_invitation_config',
  CustomTheme = 'custom_theme',
  ExhibitionAppImageLabel = 'exhibition_app_image_label',
  ExhibitionAppImageLabelEn = 'exhibition_app_image_label_en',
  ExhibitionAppImageMaxCount = 'exhibition_app_image_max_count',
  ExhibitionAppImageMinCount = 'exhibition_app_image_min_count',
  FairGroupsByCategory = 'fair_groups_by_category',
  InterviewExample = 'interview_example',
  InterviewExampleEng = 'interview_example_eng',
  InterviewFile = 'interview_file',
  InvitationLinkManualUrl = 'invitation_link_manual_url',
  Join = 'join',
  JoinEng = 'join_eng',
  JoinMarketing = 'join_marketing',
  LinkonbizConfig = 'linkonbiz_config',
  LinkonbizPrivacy = 'linkonbiz_privacy',
  LinkonbizPrivacyEng = 'linkonbiz_privacy_eng',
  LinkonbizRedirectPath = 'linkonbiz_redirect_path',
  LinkonbizTerm = 'linkonbiz_term',
  LinkonbizTermEng = 'linkonbiz_term_eng',
  MaxStaffCountInOnsiteStaff = 'max_staff_count_in_onsite_staff',
  PaybackChallengeConfig = 'payback_challenge_config',
  PressReleaseExample = 'press_release_example',
  PressReleaseExampleEng = 'press_release_example_eng',
  PressReleaseFile = 'press_release_file',
  PressReleaseGuideFile = 'press_release_guide_file',
  PromotionBannerConfig = 'promotion_banner_config',
  PromotionBannerConfigEng = 'promotion_banner_config_eng',
  PromotionBrandType = 'promotion_brand_type',
  PromotionMaxBrandCount = 'promotion_max_brand_count',
  PromotionUseVideo = 'promotion_use_video',
  ShowEndFair = 'show_end_fair',
  ShowPrepareFair = 'show_prepare_fair',
  UseExhibitionImage = 'use_exhibition_image',
  UseMultiLangInOnsiteStaff = 'use_multi_lang_in_onsite_staff',
  UseQuantityOnlyInOnsiteStaff = 'use_quantity_only_in_onsite_staff',
  WhiteIpList = 'white_ip_list',
  SignUpWithoutBusinessNumber = 'sign_up_without_business_number',
  ExhibitorLabel = 'exhibitor_label',
  UseUsdCurrencyOnly = 'use_usd_currency_only',
  ExhibitReqPeriodDesc = 'exhibit_req_period_desc'
}

export enum FacilityGroup {
  Value21 = 21,
  Value22 = 22,
  Value23 = 23
}

export interface ShowLangTypeSelector {
  /**
   * 언어 코드 (예: ko, en)
   * @example "ko"
   */
  value?: string
  /**
   * 언어 표시명
   * @example "한국어"
   */
  label?: string
  /**
   * 언어 아이콘 URL
   * @example "/images/flags/kr.png"
   */
  icon?: string
}

export interface CouponGuide {
  /**
   * 기업 SMS 초대 가이드 URL
   * @example "https://img.esfair.kr/fms/2025/05/31/1234567890.png"
   */
  companySmsInviteGuideUrl?: string
  /**
   * 방문객 SMS 초대 가이드 URL
   * @example "https://img.esfair.kr/fms/2025/05/31/1234567890.png"
   */
  visitorSmsInviteGuideUrl?: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'http://localhost:8001/api'
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer'
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
    return keys.map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key))).join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) => (input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input),
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob ? property : typeof property === 'object' && property !== null ? JSON.stringify(property) : `${property}`
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
  }

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    }
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {})
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body)
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title Exhibitor API
 * @version 1.0
 * @baseUrl http://localhost:8001/api
 *
 * Exhibitor API
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  common = {
    /**
     * No description
     *
     * @tags 공통
     * @name MenuItemsList
     * @summary 접근할 수 있는 메뉴를 불러옵니다
     * @request GET:/common/menuItems
     */
    menuItemsList: (
      query?: {
        /**
         * 전시회 구분 식별자
         * @example 6
         */
        fairMasterId?: number
        /**
         * 전시회 식별자
         * @example 799
         */
        fairId?: number
        /**
         * 언어 설정
         * @example "ko"
         */
        locale?: 'ko' | 'en'
      },
      params: RequestParams = {}
    ) =>
      this.request<MenuItem[], any>({
        path: `/common/menuItems`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 공통
     * @name AllSitesList
     * @summary 전체 사이트 목록을 가져옵니다
     * @request GET:/common/allSites
     */
    allSitesList: (params: RequestParams = {}) =>
      this.request<SiteConfigDto[], any>({
        path: `/common/allSites`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 공통
     * @name BannerSizesDetail
     * @summary 배너 크기 목록을 가져옵니다
     * @request GET:/common/bannerSizes/{fairMasterId}
     */
    bannerSizesDetail: (fairMasterId: number, params: RequestParams = {}) =>
      this.request<BannerSize[], any>({
        path: `/common/bannerSizes/${fairMasterId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 공통
     * @name FairValueDetail
     * @summary 전시회에 설정된 고유의 Value 값을 가져옵니다
     * @request GET:/common/fairValue/{key}
     */
    fairValueDetail: (
      key: string,
      query: {
        /**
         * 전시회 구분 식별자
         * @example 6
         */
        fairMasterId: number
        /**
         * 전시회 식별자
         * @example 0
         */
        fairId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<object, any>({
        path: `/common/fairValue/${key}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      })
  }
  fair = {
    /**
     * No description
     *
     * @tags 참가기업
     * @name CompanyPrizesDetail
     * @summary 참가기업의 수상내역을 가져옵니다
     * @request GET:/fair/companyPrizes/{exhibitorId}/{regGb}
     */
    companyPrizesDetail: (exhibitorId: number, regGb: string, params: RequestParams = {}) =>
      this.request<CompanyPrize[], any>({
        path: `/fair/companyPrizes/${exhibitorId}/${regGb}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name GetFairEventDetail
     * @summary 참가기업의 전시회 이벤트 정보를 가져옵니다
     * @request GET:/fair/getFairEvent/{exhibitorId}/{type}
     */
    getFairEventDetail: (exhibitorId: number, type: number, params: RequestParams = {}) =>
      this.request<FairEvent, any>({
        path: `/fair/getFairEvent/${exhibitorId}/${type}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name FacilityDetail
     * @summary 시설 목록을 가져옵니다
     * @request GET:/fair/{fairId}/facility/{facilityType}
     */
    facilityDetail: (
      fairId: number,
      facilityType: 'booth' | 'others' | 'etc',
      query?: {
        /**
         * 해외 기업 여부
         * @default false
         */
        isOverseaCompany?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<Facility[], any>({
        path: `/fair/${fairId}/facility/${facilityType}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name AgreementDetail
     * @summary 특정 전시회의 약관 정보를 가져옵니다
     * @request GET:/fair/agreement/{agreementType}/{fairMasterId}
     */
    agreementDetail: (
      agreementType: AgreementType,
      fairMasterId: number,
      query?: {
        /**
         * 언어 설정
         * @example "ko"
         */
        locale?: 'ko' | 'en'
      },
      params: RequestParams = {}
    ) =>
      this.request<Agreement, void>({
        path: `/fair/agreement/${agreementType}/${fairMasterId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name ApplicationFormSettingsDetail
     * @summary 전시회의 양식 설정 정보를 가져옵니다
     * @request GET:/fair/applicationFormSettings/{fairMasterId}/{fairId}
     */
    applicationFormSettingsDetail: (fairMasterId: number, fairId: number, params: RequestParams = {}) =>
      this.request<ApplicationFormSettings, any>({
        path: `/fair/applicationFormSettings/${fairMasterId}/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name BoothDesignsList
     * @summary 부스 디자인 목록을 가져옵니다
     * @request GET:/fair/boothDesigns
     */
    boothDesignsList: (
      query: {
        /**
         * 전시회 식별자
         * @example 839
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 77
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<SimpleFileDto[], any>({
        path: `/fair/boothDesigns`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name OnsiteStaffOptionsList
     * @summary 상주요원 출입증 옵션
     * @request GET:/fair/onsiteStaffOptions
     */
    onsiteStaffOptionsList: (
      query: {
        /**
         * 전시회 식별자
         * @example 839
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 77
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<OnsiteStaffOptionDto, any>({
        path: `/fair/onsiteStaffOptions`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name BannerImageList
     * @summary 현수막 시안 이미지
     * @request GET:/fair/bannerImage
     */
    bannerImageList: (
      query: {
        /**
         * 전시회 식별자
         * @example 748
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 23
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/fair/bannerImage`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name BidNoticeSearchKeywordsList
     * @summary 지원사업공고 검색 키워드를 가져옵니다
     * @request GET:/fair/bidNoticeSearchKeywords
     */
    bidNoticeSearchKeywordsList: (
      query: {
        /**
         * 전시회 구분 식별자
         * @example 6
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<string[], any>({
        path: `/fair/bidNoticeSearchKeywords`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name CustomImageInvitationConfigList
     * @summary 맞춤형 이미지 초청장 설정값
     * @request GET:/fair/customImageInvitationConfig
     */
    customImageInvitationConfigList: (
      query: {
        /**
         * 전시회 식별자
         * @example 835
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 5
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<CustomImageEditorConfigDto, any>({
        path: `/fair/customImageInvitationConfig`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name BasicImageInvitationConfigList
     * @summary 기본형 이미지 초청장 설정값
     * @request GET:/fair/basicImageInvitationConfig
     */
    basicImageInvitationConfigList: (
      query: {
        /**
         * 전시회 식별자
         * @example 835
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 5
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<CustomImageEditorConfigDto, any>({
        path: `/fair/basicImageInvitationConfig`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name PaybackChallengeConfigList
     * @summary 페이백 챌린지 설정값 (커스텀 초청장 사용 여부, 혜택 등)
     * @request GET:/fair/paybackChallengeConfig
     */
    paybackChallengeConfigList: (
      query: {
        /**
         * 전시회 식별자
         * @example 835
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 5
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<PaybackChallengeConfigDto, any>({
        path: `/fair/paybackChallengeConfig`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name PromotionBannerConfigList
     * @summary 홍보 배너 설정값 (예시 이미지, 배너 이미지 세팅 설정값 등)
     * @request GET:/fair/promotionBannerConfig
     */
    promotionBannerConfigList: (
      query: {
        /**
         * 전시회 식별자
         * @example 844
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 54
         */
        fairMasterId: number
        /**
         * 언어 설정
         * @example "ko"
         */
        locale?: 'ko' | 'en'
      },
      params: RequestParams = {}
    ) =>
      this.request<PromotionBannerConfigDto, any>({
        path: `/fair/promotionBannerConfig`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name PressReleaseAndInterviewResourcesList
     * @summary 보도자료/인터뷰 신청서 파일 및 예시 링크
     * @request GET:/fair/pressReleaseAndInterviewResources
     */
    pressReleaseAndInterviewResourcesList: (
      query: {
        /**
         * 전시회 구분 식별자
         * @example 30
         */
        fairMasterId: number
        /**
         * 한국어 사용 여부
         * @example true
         */
        isKorean?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<PressReleaseAndInterviewDto, any>({
        path: `/fair/pressReleaseAndInterviewResources`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name FairGroupsByCategoryList
     * @summary 전시 카테고리 대분류별 세부 전시 ex. 고기능소재위크 - 코팅코리아, 썰텍코리아, ...
     * @request GET:/fair/fairGroupsByCategory
     */
    fairGroupsByCategoryList: (
      query: {
        /**
         * 전시회 구분 식별자
         * @example 54
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<FairGroupsByCategoryDto[], any>({
        path: `/fair/fairGroupsByCategory`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name ConstructionCompanyConfigList
     * @summary 시공사 등록 메뉴 설정
     * @request GET:/fair/constructionCompanyConfig
     */
    constructionCompanyConfigList: (
      query: {
        /**
         * 전시회 식별자
         * @example 699
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 6
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ConstructionCompanyConfigDto, any>({
        path: `/fair/constructionCompanyConfig`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name LinkonbizConfigList
     * @summary 링크온비즈 바로가기 (온라인 제품 등록) 메뉴 설정
     * @request GET:/fair/linkonbizConfig
     */
    linkonbizConfigList: (
      query: {
        /**
         * 전시회 식별자
         * @example 0
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 23
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<LinkonbizConfigDto, any>({
        path: `/fair/linkonbizConfig`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name OnlinePromotionConfigList
     * @summary 온라인 홍보 자료 등록 메뉴 설정
     * @request GET:/fair/onlinePromotionConfig
     */
    onlinePromotionConfigList: (
      query: {
        /**
         * 전시회 식별자
         * @example 699
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 6
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<OnlinePromotionConfigDto, any>({
        path: `/fair/onlinePromotionConfig`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name FairPeriodList
     * @summary 메뉴별 신청기간 설정
     * @request GET:/fair/fairPeriod
     */
    fairPeriodList: (
      query: {
        /**
         * 전시회 식별자
         * @example 745
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 1
         */
        periodType: number
        /**
         * 전시회 구분 식별자
         * @example null
         */
        subPeriodType?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<FairPeriod, any>({
        path: `/fair/fairPeriod`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name ListByFairMasterIdDetail
     * @summary 전시회 구분자를 통한 열린 전시회 조회
     * @request GET:/fair/listByFairMasterId/{fairMasterId}
     */
    listByFairMasterIdDetail: (fairMasterId: number, params: RequestParams = {}) =>
      this.request<FairDto[], any>({
        path: `/fair/listByFairMasterId/${fairMasterId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name GetCompanyNamesDetail
     * @summary 참가기업 명칭 조회
     * @request GET:/fair/getCompanyNames/{exhibitorId}
     */
    getCompanyNamesDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<CompanyNames[], any>({
        path: `/fair/getCompanyNames/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name FairDetail
     * @summary 전시회 정보 조회
     * @request GET:/fair/{fairId}
     */
    fairDetail: (fairId: number, params: RequestParams = {}) =>
      this.request<Fair, any>({
        path: `/fair/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name ManualDownloadDetail
     * @summary 참가기업 메뉴얼 다운로드
     * @request GET:/fair/manualDownload/{fairId}
     */
    manualDownloadDetail: (fairId: number, params: RequestParams = {}) =>
      this.request<FairManualFile[], any>({
        path: `/fair/manualDownload/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name FairCategorySubDetail
     * @summary 전시회 구분자를 통한 전시회 카테고리 조회
     * @request GET:/fair/fairCategorySub/{fairMasterId}
     */
    fairCategorySubDetail: (fairMasterId: number, params: RequestParams = {}) =>
      this.request<FairCategorySub[], any>({
        path: `/fair/fairCategorySub/${fairMasterId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name GetCompanyPreFairReqDetail
     * @summary 기업의 전시회 신청 정보 조회
     * @request GET:/fair/getCompanyPreFairReq/{companyId}/{fairMasterId}/{currentFairId}
     */
    getCompanyPreFairReqDetail: (companyId: number, fairMasterId: number, currentFairId: number, params: RequestParams = {}) =>
      this.request<CompanyPreFairReq, any>({
        path: `/fair/getCompanyPreFairReq/${companyId}/${fairMasterId}/${currentFairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name GetCompanyPromotionCategoriesDetail
     * @summary 기업이 선택한 프로모션 카테고리 조회
     * @request GET:/fair/getCompanyPromotionCategories/{companyFairPromotionId}
     */
    getCompanyPromotionCategoriesDetail: (companyFairPromotionId: number, params: RequestParams = {}) =>
      this.request<ExhibitorPromotionCategory[], any>({
        path: `/fair/getCompanyPromotionCategories/${companyFairPromotionId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name FairCategoryListDetail
     * @summary 해당 전시회 분류에 속해있는 카테고리들을 불러옴
     * @request GET:/fair/fairCategoryList/{fairMasterId}
     */
    fairCategoryListDetail: (
      fairMasterId: number,
      query?: {
        /**
         * 언어 설정
         * @example "ko"
         */
        locale?: 'ko' | 'en'
      },
      params: RequestParams = {}
    ) =>
      this.request<FairCategory[], any>({
        path: `/fair/fairCategoryList/${fairMasterId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name ApplicationAddInfoListDetail
     * @summary FAIR_ID를 통해 해당 전시회의 추가정보 입력값들을 불러옴
     * @request GET:/fair/applicationAddInfoList/{fairId}
     */
    applicationAddInfoListDetail: (
      fairId: number,
      query?: {
        /**
         * 언어 설정
         * @example "ko"
         */
        locale?: 'ko' | 'en'
      },
      params: RequestParams = {}
    ) =>
      this.request<FairApplicationAddInfoGroup[], any>({
        path: `/fair/applicationAddInfoList/${fairId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name FairPollsList
     * @summary FAIR_ID를 통해 해당 전시회의 설문조사 정보를 불러옴
     * @request GET:/fair/fairPolls
     */
    fairPollsList: (
      query?: {
        /**
         * 전시회 구분 식별자
         * @example 737
         */
        fairId?: number
        /**
         * 전시회 상담 식별자
         * @example 54
         */
        fairConsultId?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<FairPollDto[], any>({
        path: `/fair/fairPolls`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name GetFairInfoDetail
     * @summary 전시회 정보 조회
     * @request GET:/fair/getFairInfo/{fairId}
     */
    getFairInfoDetail: (fairId: number, params: RequestParams = {}) =>
      this.request<FairInfo, any>({
        path: `/fair/getFairInfo/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name FairDocDetail
     * @summary 홍보물 표기용 회사명 페이지 정보 + 상주요원 출입증 발급 수량 단위
     * @request GET:/fair/fairDoc/{fairId}
     */
    fairDocDetail: (fairId: number, params: RequestParams = {}) =>
      this.request<FairDoc, any>({
        path: `/fair/fairDoc/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name FairPromotionOptionsDetail
     * @summary 온라인 홍보자료 및 보도자료 배포 신청 메뉴에서 해당 항목을 사용할지 옵션들
     * @request GET:/fair/fairPromotionOptions/{fairId}
     */
    fairPromotionOptionsDetail: (fairId: number, params: RequestParams = {}) =>
      this.request<FairPromotionOption, any>({
        path: `/fair/fairPromotionOptions/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      })
  }
  media = {
    /**
     * No description
     *
     * @tags Media
     * @name UploadCreate
     * @summary 파일을 업로드합니다
     * @request POST:/media/upload
     */
    uploadCreate: (
      query: {
        /**
         * 저장 경로
         * @example "test/of/media"
         */
        path: string
      },
      data: {
        /** @format binary */
        file: File
        /**
         * 이미지 파일의 경우 섬네일을 제작합니다
         * @default true
         * @example true
         */
        createThumbnails?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<SingleFileUploadDto, any>({
        path: `/media/upload`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Media
     * @name UploadsCreate
     * @summary 파일들을 업로드합니다
     * @request POST:/media/uploads
     */
    uploadsCreate: (
      data: {
        'file[]': File[]
        /**
         * 저장 경로
         * @default "unknown"
         * @example "demo"
         */
        path: string
        /**
         * @default true
         * @example true
         */
        createThumbnails?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<SingleFileUploadDto[], any>({
        path: `/media/uploads`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params
      })
  }
  member = {
    /**
     * No description
     *
     * @tags 기업회원
     * @name LoginCreate
     * @summary 로그인을 시도해서 세션을 획득합니다
     * @request POST:/member/login
     */
    loginCreate: (
      data: {
        /** @example "test400" */
        loginId?: string
        /** @example 1234 */
        password?: string
        /** @example false */
        rememberMe?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<Member, any>({
        path: `/member/login`,
        method: 'POST',
        body: data,
        type: ContentType.UrlEncoded,
        format: 'json',
        ...params
      }),

    /**
     * @description FMS 에서 관리자로 로그인을 들어올 경우 자동 로그인 시킨다. 만약 로그인이 되어있다면 기존 계정을 로그아웃 시킨 후 요청이 온 정보로 로그인 시킨다.
     *
     * @tags 기업회원
     * @name LoginFromFmsList
     * @summary FMS 에서 관리자로 로그인을 들어올 경우 자동 로그인 시킨다
     * @request GET:/member/loginFromFms
     */
    loginFromFmsList: (
      query: {
        /**
         * 내부 페이로드
         *
         * | Key | 설명 |
         * | --- | --- |
         * | loginId | 참가기업 로그인 아이디 |
         * | password | 참가기업 패스워드 |
         * | fairMasterId | 전시회 구분 식별자 (integer) |
         *
         * ```json
         * {
         *   "loginId": "test400",
         *   "password": "1234",
         *   "fairMasterId": 40
         * }
         * ```
         * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ0ZXN0NDAwIiwibmFtZSI6InRlc3Q0MDAiLCJpYXQiOjE2ODQ4NTYxMjEsImV4cCI6MTY4NDg1OTcyMX0.7v8kz5qj7f3a8b2e3d"
         */
        token: string
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void>({
        path: `/member/loginFromFms`,
        method: 'GET',
        query: query,
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업회원
     * @name LogoutUpdate
     * @summary 세션을 제거하여 로그아웃을 합니다
     * @request PUT:/member/logout
     */
    logoutUpdate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/member/logout`,
        method: 'PUT',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업회원
     * @name MyProfileList
     * @summary 내 정보 가져오기
     * @request GET:/member/myProfile
     */
    myProfileList: (params: RequestParams = {}) =>
      this.request<Member, any>({
        path: `/member/myProfile`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업회원
     * @name JoinCreate
     * @summary 기업 회원 가입
     * @request POST:/member/join
     */
    joinCreate: (data: CompanyJoinDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/member/join`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업회원
     * @name ByBizNumberDetail
     * @summary 사업자번호로 등록된 계정 목록 조회
     * @request GET:/member/byBizNumber/{bizNumber}
     */
    byBizNumberDetail: (bizNumber: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example "test123" */
          loginId: string
          /** @example "tes***sdf@example.com" */
          email: string
        }[],
        any
      >({
        path: `/member/byBizNumber/${bizNumber}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업회원
     * @name VerifyByEmailCreate
     * @summary 인증 메일 절차를 시작, 메일을 발송함
     * @request POST:/member/verifyByEmail
     */
    verifyByEmailCreate: (
      data: {
        /** @example "test400abc" */
        loginId?: string
        /** @example 23 */
        fairMasterId?: number
        /** 언어 유형 */
        locale?: Locale
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/member/verifyByEmail`,
        method: 'POST',
        body: data,
        type: ContentType.UrlEncoded,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업회원
     * @name CheckCodeByEmailCreate
     * @summary 메일 인증 코드 확인
     * @request POST:/member/checkCodeByEmail
     */
    checkCodeByEmailCreate: (
      data: {
        /** @example "test400abc" */
        loginId?: string
        /** @example "123456" */
        certCode?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/member/checkCodeByEmail`,
        method: 'POST',
        body: data,
        type: ContentType.UrlEncoded,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업회원
     * @name ResetPasswordUpdate
     * @summary 비밀번호 재설정
     * @request PUT:/member/resetPassword
     */
    resetPasswordUpdate: (
      data: {
        /** @example "test123" */
        loginId?: string
        /** @example "hmsun.es@esgroup.net" */
        email?: string
        /** @example "newPassword123!" */
        newPassword: string
        /** @example "123456" */
        certCode: string
      },
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/member/resetPassword`,
        method: 'PUT',
        body: data,
        type: ContentType.UrlEncoded,
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업회원
     * @name CheckJoinIdList
     * @summary 회원가입 시 로그인 아이디 중복 확인
     * @request GET:/member/checkJoinId
     */
    checkJoinIdList: (
      query: {
        /**
         * 확인할 로그인 아이디
         * @example "test400"
         */
        loginId: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /**
           * 아이디 중복 여부 (true: 중복, false: 사용 가능)
           * @example false
           */
          isDuplicated: boolean
        },
        string
      >({
        path: `/member/checkJoinId`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업회원
     * @name CheckJoinEmailList
     * @summary 회원가입 시 이메일 중복 확인
     * @request GET:/member/checkJoinEmail
     */
    checkJoinEmailList: (
      query: {
        /**
         * 확인할 이메일 주소
         * @example "hmsun.es@esgroup.net"
         */
        email: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /**
           * 이메일 중복 여부 (true: 중복, false: 사용 가능)
           * @example false
           */
          isDuplicated: boolean
        },
        string
      >({
        path: `/member/checkJoinEmail`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * @description 로그인한 회원의 비밀번호를 변경합니다.
     *
     * @tags 기업회원
     * @name UpdatePasswordUpdate
     * @summary 회원 비밀번호 변경
     * @request PUT:/member/updatePassword
     */
    updatePasswordUpdate: (
      data: {
        /** 현재 비밀번호 */
        currentPassword: string
        /** 새 비밀번호 */
        newPassword: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiResponse, ApiErrorResponse>({
        path: `/member/updatePassword`,
        method: 'PUT',
        body: data,
        type: ContentType.UrlEncoded,
        format: 'json',
        ...params
      }),

    /**
     * @description 로그인한 회원의 업체 정보를 변경합니다.
     *
     * @tags 기업회원
     * @name UpdateCompanyInfoUpdate
     * @summary 회원 업체 정보 변경
     * @request PUT:/member/updateCompanyInfo
     */
    updateCompanyInfoUpdate: (data: UpdateCompanyInfoDto, params: RequestParams = {}) =>
      this.request<ApiResponse, ApiErrorResponse>({
        path: `/member/updateCompanyInfo`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description 이메일 변경을 위한 인증 코드를 전송합니다.
     *
     * @tags Member
     * @name SendEmailVerificationCreate
     * @summary 이메일 인증 코드 전송
     * @request POST:/member/sendEmailVerification
     * @secure
     */
    sendEmailVerificationCreate: (
      data: {
        /**
         * 변경할 이메일 주소
         * @format email
         */
        email: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ApiResponse, ApiErrorResponse>({
        path: `/member/sendEmailVerification`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  }
  exhibitor = {
    /**
     * No description
     *
     * @tags 참가기업
     * @name InfoImagesDetail
     * @summary 참가기업 대표 이미지 (캣페스타)
     * @request GET:/exhibitor/infoImages/{exhibitorId}
     */
    infoImagesDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/exhibitor/infoImages/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name ReqInfoDetail
     * @summary 참가기업 신청 정보 조회
     * @request GET:/exhibitor/reqInfo/{exhibitorId}
     */
    reqInfoDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/exhibitor/reqInfo/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name ReqPromotionDetail
     * @summary 참가기업 전시회 프로모션 정보 조회
     * @request GET:/exhibitor/reqPromotion/{exhibitorId}
     */
    reqPromotionDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<ExhibitorReqPromotion, any>({
        path: `/exhibitor/reqPromotion/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name CsStaffDetail
     * @summary 참가기업 식별자를 이용해, 현장 CS 담당자 정보를 가져옵니다
     * @request GET:/exhibitor/csStaff/{fairId}/{exhibitorId}
     */
    csStaffDetail: (fairId: number, exhibitorId: number, params: RequestParams = {}) =>
      this.request<ExhibitorCsStaff, any>({
        path: `/exhibitor/csStaff/${fairId}/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name SaveCsStaffCreate
     * @summary 현장 CS 담당자 정보를 저장합니다
     * @request POST:/exhibitor/saveCsStaff
     */
    saveCsStaffCreate: (data: ExhibitorCsStaff, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/exhibitor/saveCsStaff`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name SaveConstructorCreate
     * @summary 참가기업 시공업체 정보 저장
     * @request POST:/exhibitor/saveConstructor
     */
    saveConstructorCreate: (data: ExhibitorConstructor, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/exhibitor/saveConstructor`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name StaffDetail
     * @summary 참가기업 직원 정보 조회
     * @request GET:/exhibitor/staff/{exhibitorId}
     */
    staffDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<
        {
          result?: string
          data?: ExhibitorStaff[]
        },
        any
      >({
        path: `/exhibitor/staff/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name SaveStaffCreate
     * @summary 참가기업 직원 정보 저장
     * @request POST:/exhibitor/saveStaff
     */
    saveStaffCreate: (data: ExhibitorStaff, params: RequestParams = {}) =>
      this.request<ApiResponse, any>({
        path: `/exhibitor/saveStaff`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name DeleteStaffDelete
     * @summary 참가기업 직원 정보 삭제
     * @request DELETE:/exhibitor/deleteStaff/{staffId}
     */
    deleteStaffDelete: (staffId: number, params: RequestParams = {}) =>
      this.request<ApiResponse, any>({
        path: `/exhibitor/deleteStaff/${staffId}`,
        method: 'DELETE',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name ApplicationDetail
     * @summary 참가기업 신청 정보 조회
     * @request GET:/exhibitor/application/{exhibitorId}
     */
    applicationDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<FairApplicationForm, any>({
        path: `/exhibitor/application/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name BeforeApplicationDetail
     * @summary 전시회 구분자를 통한 참가기업 이전 신청 정보 조회
     * @request GET:/exhibitor/beforeApplication/{fairMasterId}
     */
    beforeApplicationDetail: (
      fairMasterId: number,
      query?: {
        /** 전시회 식별자 */
        exceptFairId?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<FairApplicationForm, any>({
        path: `/exhibitor/beforeApplication/${fairMasterId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 전시회
     * @name InfoImagesDetailDetail
     * @summary 전시회 대표 이미지 상세 (캣페스타)
     * @request GET:/exhibitor/infoImagesDetail/{exhibitorId}
     */
    infoImagesDetailDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<ExhibitorInfoImage[], any>({
        path: `/exhibitor/infoImagesDetail/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name GetCompanySmsCouponListCreate
     * @summary 참가기업 SMS 쿠폰 목록 조회
     * @request POST:/exhibitor/getCompanySmsCouponList
     */
    getCompanySmsCouponListCreate: (
      data: {
        /** @example 1 */
        currentPageIndex?: number
        /** @example 10 */
        pageViewCount?: number
        /** @example 1950959 */
        exhibitorId?: number
        /** @example "" */
        mobile?: string
        /** @example "" */
        email?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<CompanySmsCoupon[], any>({
        path: `/exhibitor/getCompanySmsCouponList`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name ByFairDetail
     * @summary 참가기업의 식별 코드를 전시회를 통해 가져옴
     * @request GET:/exhibitor/byFair/{fairId}
     */
    byFairDetail: (fairId: number, params: RequestParams = {}) =>
      this.request<Exhibitor, any>({
        path: `/exhibitor/byFair/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name GetFairCouponGuideDetail
     * @summary 전시회 쿠폰 가이드 정보를 가져옵니다
     * @request GET:/exhibitor/getFairCouponGuide/{fairId}
     */
    getFairCouponGuideDetail: (fairId: number, params: RequestParams = {}) =>
      this.request<FairCouponGuide, any>({
        path: `/exhibitor/getFairCouponGuide/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name ReceiptsDetail
     * @summary 참가기업가 신청한 출품 구매 요약을 알려줌
     * @request GET:/exhibitor/receipts/{exhibitorId}
     */
    receiptsDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<ExhibitorReceipt[], any>({
        path: `/exhibitor/receipts/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name BrandSignDetail
     * @summary 참가기업의 브랜드 이름 등록 정보를 가져옵니다
     * @request GET:/exhibitor/brandSign/{exhibitorId}
     */
    brandSignDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<ExhibitorDoc, any>({
        path: `/exhibitor/brandSign/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name InviteLinkDetail
     * @summary 참가기업 초대 링크 생성
     * @request GET:/exhibitor/inviteLink/{fairId}/{fairMasterId}/{fairMasterCd}/{companyId}/{exhibitorId}/{companyName}/{langType}/{locationOrigin}/{siteCode}
     */
    inviteLinkDetail: (
      fairId: number,
      fairMasterId: number,
      fairMasterCd: string,
      companyId: number,
      exhibitorId: number,
      companyName: string,
      langType?: string,
      locationOrigin?: string,
      siteCode?: string,
      query?: {
        /**
         * 초대 링크 ID
         * @example 1234567890
         */
        ivctid?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ExhibitorInviteLink, any>({
        path: `/exhibitor/inviteLink/${fairId}/${fairMasterId}/${fairMasterCd}/${companyId}/${exhibitorId}/${companyName}/${langType}/${locationOrigin}/${siteCode}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name VerifyInviteInfoCreate
     * @summary 참가기업 초청장
     * @request POST:/exhibitor/verifyInviteInfo
     */
    verifyInviteInfoCreate: (data: VerifyCodeAndFetchInviteInfoDto, params: RequestParams = {}) =>
      this.request<any[], any>({
        path: `/exhibitor/verifyInviteInfo`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name SaveBrandSignCreate
     * @summary 참가기업 가입자 식별 코드를 저장
     * @request POST:/exhibitor/saveBrandSign
     */
    saveBrandSignCreate: (data: ExhibitorDoc, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/exhibitor/saveBrandSign`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name PromotionDetail
     * @summary 참가기업의 보도자료 정보를 가져옵니다
     * @request GET:/exhibitor/promotion/{exhibitorId}
     */
    promotionDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<Promotion, any>({
        path: `/exhibitor/promotion/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name RequestPressReleaseCreate
     * @summary 참가기업 보도 자료 등록
     * @request POST:/exhibitor/requestPressRelease
     */
    requestPressReleaseCreate: (data: PressRelease, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/exhibitor/requestPressRelease`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name BannerDetail
     * @summary 참가기업의 배너 정보를 가져옵니다
     * @request GET:/exhibitor/banner/{exhibitorId}
     */
    bannerDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<BannerForm, any>({
        path: `/exhibitor/banner/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name SubmitBannerFormCreate
     * @summary 참가기업 현수막 신청 양식을 제출
     * @request POST:/exhibitor/submitBannerForm
     */
    submitBannerFormCreate: (data: BannerForm, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/exhibitor/submitBannerForm`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description ## 참가기업 출품 시설 정보 입력
     *
     * @tags 참가기업
     * @name RequestFacilitiesCreate
     * @summary 참가기업 출품 시설 정보 입력
     * @request POST:/exhibitor/requestFacilities
     */
    requestFacilitiesCreate: (
      data: {
        exhibitorId?: number
        /** 시설 요청이 필요하지 않을 경우 관련 담당자를 적도록 합니다 */
        facilityStaffName?: string
        companyName?: string
        email?: string
        telephone?: string
        fairName?: string
        fairEmail?: string
        facilities: FacilityReq[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example 1 */
          ERR_CD?: number
          /** @example "성공" */
          ERR_MSG?: string
        }[],
        any
      >({
        path: `/exhibitor/requestFacilities`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name FacilitiesDetail
     * @summary 참가기업 출품 시설 정보를 가져옵니다
     * @request GET:/exhibitor/facilities/{exhibitorId}
     */
    facilitiesDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<FacilitiesRequestHistory, any>({
        path: `/exhibitor/facilities/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name ConstructorDetail
     * @summary 참가기업 시공업체 정보를 가져옵니다
     * @request GET:/exhibitor/constructor/{exhibitorId}
     */
    constructorDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<ExhibitorConstructor, any>({
        path: `/exhibitor/constructor/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name SaveOnsiteStaffsCreate
     * @summary 참가기업 상주요원 출입증 등록 및 수정
     * @request POST:/exhibitor/saveOnsiteStaffs
     */
    saveOnsiteStaffsCreate: (data: OnsiteStaffDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/exhibitor/saveOnsiteStaffs`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name SaveCompanyFairDocCreate
     * @summary 참가기업 등록 서류 (COMPANY_FAIR_DOC) 등록 및 수정
     * @request POST:/exhibitor/saveCompanyFairDoc
     */
    saveCompanyFairDocCreate: (data: CompanyFairDocDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/exhibitor/saveCompanyFairDoc`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name DeleteOnsiteStaffDelete
     * @summary 참가기업 상주요원 출입증 단일 행 삭제
     * @request DELETE:/exhibitor/deleteOnsiteStaff
     */
    deleteOnsiteStaffDelete: (data: DeleteOnsiteStaffDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/exhibitor/deleteOnsiteStaff`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name OnsiteStaffsDetail
     * @summary 참가기업 상주요원 출입증 정보를 가져옴
     * @request GET:/exhibitor/onsiteStaffs/{exhibitorId}
     */
    onsiteStaffsDetail: (exhibitorId: number, params: RequestParams = {}) =>
      this.request<ExhibitorOnsiteStaff[], any>({
        path: `/exhibitor/onsiteStaffs/${exhibitorId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name SubmitApplicationCreate
     * @summary 참가기업 신청서 등록/제출
     * @request POST:/exhibitor/submitApplication
     */
    submitApplicationCreate: (data: FairApplicationForm, params: RequestParams = {}) =>
      this.request<SubmitApplicationResult, any>({
        path: `/exhibitor/submitApplication`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 초대장
     * @name InitInviteApplicationList
     * @summary 참가기업 초대장 초기 데이터 로드
     * @request GET:/exhibitor/initInviteApplication
     */
    initInviteApplicationList: (
      query: {
        /** 토큰 */
        token: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          couponGuide?: object | null
          fairInfo?: object
          nation?: any[]
          terms?: any[]
          inviteFormOptions?: object
          resultCode?: number
        },
        any
      >({
        path: `/exhibitor/initInviteApplication`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 초대장
     * @name SubmitInviteApplicationCreate
     * @summary 참가기업 초대장 참관객 신청 정보 등록
     * @request POST:/exhibitor/submitInviteApplication
     */
    submitInviteApplicationCreate: (data: InviteApplicationForm, params: RequestParams = {}) =>
      this.request<SubmitInviteApplicationResult, any>({
        path: `/exhibitor/submitInviteApplication`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name ConsultReqDetail
     * @summary 컨설팅관 신청자 리스트
     * @request GET:/exhibitor/consultReq/{exhibitorId}/{fairConsultId}
     */
    consultReqDetail: (exhibitorId: number, fairConsultId: number, params: RequestParams = {}) =>
      this.request<ConsultReqDto[], any>({
        path: `/exhibitor/consultReq/${exhibitorId}/${fairConsultId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name ConsultingExhibitorsDetail
     * @summary 컨설팅관에 등록된 기업 목록
     * @request GET:/exhibitor/consultingExhibitors/{fairConsultId}
     */
    consultingExhibitorsDetail: (fairConsultId: number, params: RequestParams = {}) =>
      this.request<ConsultingExhibitorDto[], any>({
        path: `/exhibitor/consultingExhibitors/${fairConsultId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name ExhibitorFacilitiesList
     * @summary 참가업체 시설 신청 내역
     * @request GET:/exhibitor/exhibitorFacilities
     */
    exhibitorFacilitiesList: (
      query: {
        /** 참가업체 식별자 */
        exhibitorId: number
        /** 전시회 식별자 */
        fairId: number
        /** 시설 그룹 - 부스, 부대시설, 기타시설 */
        facilityGroup: FacilityGroup
      },
      params: RequestParams = {}
    ) =>
      this.request<ExhibitorFacilityDto[], any>({
        path: `/exhibitor/exhibitorFacilities`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 참가기업
     * @name GetInvitationSettingsList
     * @summary 초대 관련 설정들을 한 번에 가져옵니다
     * @request GET:/exhibitor/getInvitationSettings
     */
    getInvitationSettingsList: (
      query: {
        /**
         * 전시회 식별자
         * @example 835
         */
        fairId: number
        /**
         * 전시회 마스터 식별자
         * @example 123
         */
        fairMasterId: number
        /**
         * 참가기업 식별자
         * @example 1950959
         */
        exhibitorId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** 쿠폰 사용 가능 여부 */
          couponEnable?: boolean
          /** 수동 초대 링크 이미지 URL */
          manualImageUrl?: string
          /** 초대 링크 숨김 여부 */
          hideInviteLink?: boolean
          /** 언어 타입 선택기 설정 */
          showLangTypeSelector?: ShowLangTypeSelector[]
          /** 기업명 목록 */
          companyNames?: {
            value?: string
          }[]
          /** 언어 타입 선택기 설정 */
          couponGuide?: any[]
        },
        any
      >({
        path: `/exhibitor/getInvitationSettings`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      })
  }
  company = {
    /**
     * No description
     *
     * @tags 기업
     * @name PreviousStaffListDetail
     * @summary 이전 전시회 참가 스태프 목록을 가져옵니다
     * @request GET:/company/previousStaffList/{fairId}
     */
    previousStaffListDetail: (fairId: number, params: RequestParams = {}) =>
      this.request<ExhibitorStaff[], any>({
        path: `/company/previousStaffList/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name LoginBmsList
     * @summary BMS 로그인
     * @request GET:/company/loginBms
     */
    loginBmsList: (
      query: {
        /**
         * 전시회 식별자
         * @example 6
         */
        fairMasterId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void>({
        path: `/company/loginBms`,
        method: 'GET',
        query: query,
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name InfoDetail
     * @summary 내 기업 정보 가져오기
     * @request GET:/company/info/{fairId}
     */
    infoDetail: (fairId: number, params: RequestParams = {}) =>
      this.request<Company, any>({
        path: `/company/info/${fairId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name ByBizNumberDetail
     * @summary 사업자번호로 회원가입여부 체크
     * @request GET:/company/byBizNumber/{bizNumber}
     */
    byBizNumberDetail: (bizNumber: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/company/byBizNumber/${bizNumber}`,
        method: 'GET',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name LinkonbizUrlList
     * @summary 링크온비즈로 로그인 이동을 위한 URL 가져오기
     * @request GET:/company/linkonbizUrl
     */
    linkonbizUrlList: (
      query: {
        /**
         * 전시회 식별자
         * @example 737
         */
        fairId: number
        /**
         * 전시회 구분 식별자
         * @example 23
         */
        fairMasterId: number
        /**
         * 언어 설정
         * @example "ko"
         */
        locale?: 'ko' | 'en'
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example "https://linkonbiz.com/account/postAutoLogin" */
          url?: string
          /** @example 123456789 */
          token?: string
          /** @example null */
          redirectPath?: string | null
        },
        any
      >({
        path: `/company/linkonbizUrl`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name AgreeLinkonbizCreate
     * @summary 링크온비즈 이용 동의
     * @request POST:/company/agreeLinkonbiz
     */
    agreeLinkonbizCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/company/agreeLinkonbiz`,
        method: 'POST',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name UploadBusinessFileCreate
     * @summary 링크온비즈 이용 동의
     * @request POST:/company/uploadBusinessFile
     */
    uploadBusinessFileCreate: (
      data: {
        /** @format binary */
        bizFile: File
        /** @example 808 */
        fairId?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          result?: {
            id?: number
            /** @format uri */
            url?: string
          }
        },
        any
      >({
        path: `/company/uploadBusinessFile`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name CompanyCouponDetail
     * @summary 코베 쿠폰 정보 가져오기
     * @request GET:/company/companyCoupon/{fairId}/{companyId}
     */
    companyCouponDetail: (fairId: number, companyId: number, params: RequestParams = {}) =>
      this.request<CompanyCouponDto, any>({
        path: `/company/companyCoupon/${fairId}/${companyId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name CompanyCouponInCobeDbDetail
     * @summary 코베 DB 내에서 쿠폰 정보 가져오기
     * @request GET:/company/companyCouponInCobeDB/{fairId}/{companyId}/{couponFlag}
     */
    companyCouponInCobeDbDetail: (fairId: number, companyId: number, couponFlag: number, params: RequestParams = {}) =>
      this.request<CompanyCouponInCobeDto[], any>({
        path: `/company/companyCouponInCobeDB/${fairId}/${companyId}/${couponFlag}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name BizFileList
     * @summary 기업 사업자 등록증 파일 조회
     * @request GET:/company/bizFile
     */
    bizFileList: (params: RequestParams = {}) =>
      this.request<CompanyBusinessFile, any>({
        path: `/company/bizFile`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name SavePaybackChallengeImageCreate
     * @summary 페이백 챌린지 초청장 이미지 저장
     * @request POST:/company/savePaybackChallengeImage
     */
    savePaybackChallengeImageCreate: (data: PaybackChallengeImage, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/company/savePaybackChallengeImage`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags 기업
     * @name PaybackChallengeImageList
     * @summary 페이백 챌린지 초청장 이미지 가져오기
     * @request GET:/company/paybackChallengeImage
     */
    paybackChallengeImageList: (
      query: {
        /**
         * 전시회 식별자
         * @example 835
         */
        fairId: number
        /**
         * 기업 식별자
         * @example 20682
         */
        companyId: number
        /**
         * 이미지 타입
         * @example "basic"
         */
        type: PaybackChallengeImageType
      },
      params: RequestParams = {}
    ) =>
      this.request<PaybackChallengeImage, any>({
        path: `/company/paybackChallengeImage`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      })
  }
  mail = {
    /**
     * No description
     *
     * @tags 메일
     * @name SendBuyerInvitationNotificationCreate
     * @summary 해외바이어 초청 프로그램 신청서 알림 메일 전송
     * @request POST:/mail/sendBuyerInvitationNotification
     */
    sendBuyerInvitationNotificationCreate: (data: BuyerInvitationDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/mail/sendBuyerInvitationNotification`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags 메일
     * @name SendCreate
     * @summary 메일 발송
     * @request POST:/mail/send/{templateClass}
     */
    sendCreate: (templateClass: string, data: SendEmailDto, params: RequestParams = {}) =>
      this.request<string, 'Invalid template class' | 'Email sending failed' | 'An unexpected error occurred'>({
        path: `/mail/send/${templateClass}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 메일
     * @name VerifyCreate
     * @summary 인증 메일 절차를 시작, 메일을 발송함
     * @request POST:/mail/verify
     */
    verifyCreate: (data: VerifyEmailDto, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/mail/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 메일
     * @name CheckCodeCreate
     * @summary 메일 인증 코드 확인
     * @request POST:/mail/checkCode
     */
    checkCodeCreate: (data: CheckEmailDto, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/mail/checkCode`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  }
  demo = {
    /**
     * No description
     *
     * @tags 데모
     * @name ProductsList
     * @request GET:/demo/products
     */
    productsList: (params: RequestParams = {}) =>
      this.request<any[], any>({
        path: `/demo/products`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags 데모
     * @name ProductsOrderedList
     * @request GET:/demo/productsOrdered
     */
    productsOrderedList: (params: RequestParams = {}) =>
      this.request<any[], any>({
        path: `/demo/productsOrdered`,
        method: 'GET',
        format: 'json',
        ...params
      })
  }
}
